<template>
  <span class="info-link-modal">
    <a
      :class="{ 'align-right': alignRight }"
      data-test="base-info-link-modal-a-tag"
      @click="toggleVisible"
    ><strong data-test="base-info-link-modal-strong" v-html="renderLinkLabel" />
    </a>
    <transition v-if="isModalVisible" name="modal">
      <v-modal
        :is-open="isModalVisible"
        data-test="base-info-link-modal"
        modal-class="alt-modal"
        @close="toggleVisible"
      >
        <template #title>
          <h2
            v-if="showTitle"
            data-test="base-info-link-modal-title"
            class="center"
            v-html="title"
          />
        </template>
        <template #content>
          <div v-if="showContent" data-test="base-info-link-modal-content" v-html="content" />
        </template>
        <template #buttons>
          <div class="row">
            <div class="small-12 columns">
              <button
                class="button text-center"
                data-test="base-info-link-modal-button"
                @click="toggleVisible"
                v-html="renderButtonLabel"
              />
            </div>
          </div>
        </template>
      </v-modal>
    </transition>
  </span>
</template>

<script lang="ts">

import { BaseInfoLinkModalData } from '@/components/Forms/BaseInfoLinkModal/types/BaseInfoLinkModal';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseInfoLinkModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    linkLabel: {
      type: String,
      default: 'Læs mere'
    },
    buttonLabel: {
      type: String,
      default: 'Luk'
    },
    alignRight: {
      type: Boolean,
      default: false
    }
  },
  data(): BaseInfoLinkModalData {
    return {
      show: false
    };
  },
  computed: {
    isModalVisible(): boolean {
      return this.show;
    },
    renderLinkLabel(): string {
      return this.linkLabel === '' || this.linkLabel === null || this.linkLabel === 'undefined'
        ? 'Læs mere'
        : this.linkLabel;
    },
    renderButtonLabel(): string {
      return this.buttonLabel === '' ||
        this.buttonLabel === null ||
        this.buttonLabel === 'undefined'
        ? 'Luk'
        : this.buttonLabel;
    },
    showTitle(): boolean {
      return this.title === '' || this.title === null || typeof this.title === 'undefined'
        ? false
        : true;
    },
    showContent(): boolean {
      return this.content === '' || this.content === null || typeof this.content === 'undefined'
        ? false
        : true;
    }
  },
  methods: {
    toggleVisible(): void {
      this.show = !this.show;
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';

.info-link-modal {
  a {
    z-index: 999;
    cursor: help;
  }

  .align-right {
    float: right;
  }
}
</style>
@/components/Feature/Forms/BaseInfoLinkModal/types/BaseInfoLinkModal
